import { TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';

import type { GalleryImageData } from '../types';

export interface GallerySlideProps {
  readonly image: GalleryImageData;
  readonly isActive: boolean;
}

const GallerySlide = ({ image, isActive }: GallerySlideProps) => {
  const t = useTranslations();

  return (
    <figure
      className="relative h-[60vw] max-h-[740px] w-[70vw] max-w-(--breakpoint-xxl) md:w-[80vw]"
      data-cy="careers-gallery-slide"
    >
      <Image
        className="w-full object-cover"
        data-cy="careers-gallery-slide-image"
        draggable={false}
        fill
        localizedAlt={image.alt}
        sizes="80vw"
        src={image.src}
      />
      {image.caption && (
        <TypographyV3
          data-cy="careers-gallery-slide-caption"
          Element="figcaption"
          weight="normal"
          color="dark"
          className={cx(
            'absolute right-0 bottom-0 z-20 float-right mt-6 inline transition-opacity',
            {
              'opacity-0': !isActive,
            },
          )}
        >
          {t(image.caption)}
        </TypographyV3>
      )}
    </figure>
  );
};

export default GallerySlide;
